$('.navbar .quick-filters [data-toggle="dropdown"]').bootstrapDropdownHover({});

//Set the logo ratio as a custom property
(function () {
    var logo = document.querySelector("header .logo");
    if(!logo) return;
    var debounce;

    setLogoRatio(logo);

    function setLogoRatio(logo) {
        clearTimeout(debounce);
        if(!logo.complete) {
            debounce = setTimeout(function(){
                setLogoRatio(logo)
            }, 100)
            return;
        }
        var width = logo.naturalWidth;
        var height = logo.naturalHeight;
        if(width <= 0 || height <= 0) return;
        var ratio = width / height;
        document.documentElement.style.setProperty('--logo-ratio', ratio);
    }
}());

(function () {
    var nav = document.querySelector("header .navbar");
    var navList = document.querySelector(".navbar-collapse");
    if(!nav) return;
    var hamburgerClass = "hamburger";
    var noAnimationClass = "resize";
    var debounceNoAnimation;
    var debounceNoAnimationTimeout = 100;
    
    preventOverflow();
    window.addEventListener("resize", preventOverflow);
    window.addEventListener("resize", noAnimation);

    //Change nav to hamburger if the scroll width exceeds the container width
    function preventOverflow(){
        nav.classList.remove(hamburgerClass);
        navList.classList.remove("collapse");
        if(nav.scrollWidth <= nav.offsetWidth) return;
        nav.classList.add(hamburgerClass);
        navList.classList.add("collapse");
    }

    //Remove transitions while resizing
    function noAnimation(){
        nav.classList.add(noAnimationClass);
        clearTimeout(debounceNoAnimation);
        debounceNoAnimation = setTimeout(function() {
            nav.classList.remove(noAnimationClass);
        }, debounceNoAnimationTimeout);
    }
    
}());
